// src/config.ts

const ENV = process.env.REACT_APP_ENV; // 'dev' or 'ftp' (production)

const config = {
    api: {
        url: ENV === 'dev'
            ? process.env.REACT_APP_API_DEV_URL
            : process.env.REACT_APP_API_URL,
    },
    front: {
        url: ENV === 'dev'
            ? process.env.REACT_APP_FRONT_DEV_URL
            : process.env.REACT_APP_FRONT_URL,
    },
    isDev: ENV === 'dev',
};

export default config;